/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dns_Propagation_Depends_On_YouInputs */

const en_dns_propagation_depends_on_you = /** @type {(inputs: Dns_Propagation_Depends_On_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DNS propagation depends on your provider. It may take anywhere from 5 to 30 minutes for changes to be discoverable globally.`)
};

const es_dns_propagation_depends_on_you = /** @type {(inputs: Dns_Propagation_Depends_On_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La propagación de DNS depende de tu proveedor. Puede tardar entre 5 y 30 minutos en aplicarse globalmente.`)
};

const fr_dns_propagation_depends_on_you = /** @type {(inputs: Dns_Propagation_Depends_On_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La propagation DNS dépend de votre fournisseur. Cela peut prendre de 5 à 30 minutes pour que les modifications soient visibles à l'échelle mondiale.`)
};

const de_dns_propagation_depends_on_you = /** @type {(inputs: Dns_Propagation_Depends_On_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die DNS-Verbreitung hängt von deinem Anbieter ab. Es kann 5 bis 30 Minuten dauern, bis Änderungen weltweit sichtbar sind.`)
};

const ja_dns_propagation_depends_on_you = /** @type {(inputs: Dns_Propagation_Depends_On_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DNSの伝播はプロバイダーによって異なります。変更がグローバルに反映されるまでに5〜30分かかる場合があります。`)
};

const zh_dns_propagation_depends_on_you = /** @type {(inputs: Dns_Propagation_Depends_On_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DNS 解析时间取决于您的服务商。全局生效可能需要 5 到 30 分钟。`)
};

const ar_dns_propagation_depends_on_you = /** @type {(inputs: Dns_Propagation_Depends_On_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`يعتمد انتشار DNS على مزود الخدمة الخاص بك. قد يستغرق الأمر من 5 إلى 30 دقيقة حتى تظهر التغييرات عالمياً.`)
};

const id_dns_propagation_depends_on_you = /** @type {(inputs: Dns_Propagation_Depends_On_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Propagasi DNS bergantung pada penyedia Anda. Mungkin butuh waktu 5 hingga 30 menit agar perubahan dapat ditemukan secara global.`)
};

const it_dns_propagation_depends_on_you = /** @type {(inputs: Dns_Propagation_Depends_On_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La propagazione del DNS dipende dal tuo provider. Potrebbe richiedere da 5 a 30 minuti affinché le modifiche siano rilevabili globalmente.`)
};

const ru_dns_propagation_depends_on_you = /** @type {(inputs: Dns_Propagation_Depends_On_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обновление DNS зависит от вашего провайдера. Изменения могут занять от 5 до 30 минут.`)
};

const pt_dns_propagation_depends_on_you = /** @type {(inputs: Dns_Propagation_Depends_On_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A propagação de DNS depende do seu provedor. Pode levar de 5 a 30 minutos para que as alterações sejam detectadas globalmente.`)
};

const ko_dns_propagation_depends_on_you = /** @type {(inputs: Dns_Propagation_Depends_On_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DNS 전파는 제공업체에 따라 다릅니다. 변경 사항이 전 세계적으로 반영되는 데 5분에서 30분 정도 걸릴 수 있습니다.`)
};

/**
* | output |
* | --- |
* | "DNS propagation depends on your provider. It may take anywhere from 5 to 30 minutes for changes to be discoverable globally." |
*
* @param {Dns_Propagation_Depends_On_YouInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const dns_propagation_depends_on_you = /** @type {((inputs?: Dns_Propagation_Depends_On_YouInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dns_Propagation_Depends_On_YouInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dns_propagation_depends_on_you(inputs)
	if (locale === "es") return es_dns_propagation_depends_on_you(inputs)
	if (locale === "fr") return fr_dns_propagation_depends_on_you(inputs)
	if (locale === "de") return de_dns_propagation_depends_on_you(inputs)
	if (locale === "ja") return ja_dns_propagation_depends_on_you(inputs)
	if (locale === "zh") return zh_dns_propagation_depends_on_you(inputs)
	if (locale === "ar") return ar_dns_propagation_depends_on_you(inputs)
	if (locale === "id") return id_dns_propagation_depends_on_you(inputs)
	if (locale === "it") return it_dns_propagation_depends_on_you(inputs)
	if (locale === "ru") return ru_dns_propagation_depends_on_you(inputs)
	if (locale === "pt") return pt_dns_propagation_depends_on_you(inputs)
	return ko_dns_propagation_depends_on_you(inputs)
});